/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell.�*/
export function getNoRowsLabel(
  searchText: string,
  filteringEnabled: boolean,
  isLoading?: boolean,
  defaultmessage?: string
) {
  let message = defaultmessage ?? "No data is available";
  if (isLoading) {
    return undefined;
  }
  if (searchText === "" && !filteringEnabled) {
    return message;
  }
  message = "No matching results found";
  if (searchText !== "" && filteringEnabled) {
    message = message + " for the searched text and filter values";
  } else if (searchText !== "") {
    message += " for the searched text";
  } else if (filteringEnabled) {
    message += " for the filtered values";
  }
  return message;
}
